<!--
 * @Author: your name
 * @Date: 2020-08-13 21:03:08
 * @LastEditTime: 2022-12-08 17:14:39
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/order-history/component/HistoryOrder/index.vue
-->
<style scoped lang="sass">
$borderColor: #f1f2f3
$detailColor: rgba(31, 196, 188, 1)

.history_order
  padding: 24px 17px 0 17px
  border-bottom: 1px solid $borderColor

  .title
    display: flex
    justify-content: space-between
    margin-bottom: 5px

    .left
      line-height: 20px
      font-size: 20px
      font-weight: 500
      color: var(--menu-primary-text-colour) !important
    .right
      line-height: 14px
      font-size: 14px
      color: var(--menu-primary-text-colour) !important
      font-weight: 500
  .time
    margin-bottom: 14px
    color: var(--menu-primary-text-colour) !important
    font-size: 10px
    line-height: 12px

  .detail
    padding-top: 20px
    padding-bottom: 10px
    font-size:12px
    line-height: 14px
    color: var(--menu-primary-background-colour) !important

</style>

<template lang="pug">
.history_order.ns
  .title
    .left {{ '#' }}{{ order.orderNo | filterOrderNo }}
    .right.ls3 {{ '$' }}{{ order.amount | fix }}
  .time.ls3 {{ formattedTime }}
  Process(
    :status="order.status"
    :payamentStatus="order.paymentStatus"
    :type="Number(order.type)"
    :orderType="order.details.orderType"
    :preOrderStartTime="order.details.preOrderStartTime"
    :showError="order.details.posStatus === 2"
  )
  .detail.p(@click="viewOrderDetail") {{ t('view_details', 'VIEW DETAILS') }}
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import 'dayjs/locale/fr'
import { _DateFilters } from 'utils/format'
import { t, getDayjsLocale } from '@/utils/language'
import { formatDecimalNumber } from '@/utils/currency'

@Component({
  props: {
    order: Object,
  },

  computed: {
    // Formatted time with locale support / 带语言支持的格式化时间
    formattedTime() {
      const _lang = this.$lang // eslint-disable-line no-unused-vars
      const locale = getDayjsLocale()
      const val = this.order.createdAtString
      const atText = t('time_at', 'AT')
      return _DateFilters(val) + ` ${atText} ` + dayjs(val).locale(locale).format('HH:mm')
    },
  },

  filters: {
    //  Filter the order number, keep the content after _
    // 过滤订单号码，保留 _ 后内容
    filterOrderNo(val) {
      const list = String(val).split('_')
      return list[list.length - 1]
    },

    fix(val) {
      return val ? formatDecimalNumber(val) : 0
    }
  }
})
class HistoryOrder extends Vue {
  t(key, fallback) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }

  goDetails() {
    let url = `/v/${this.$store.state.venueId}`
    if (this.order.venueSubGroupId) {
      url = `/vgs/${this.order.venueSubGroupId}`
    }

    if (this.order.paymentStatus !== 1 && this.order.type) {
      this.$router.push({
        path: url + `/pay/${this.order.id}`,
        query: {
          orderNo: this.order.orderNo,
          orderHistory: true,
        }
      })
    } else {
      this.$router.push({
        path: url + `/my-order/${this.order.id}`,
        query: {
          orderNo: this.order.orderNo,
          orderHistory: true,
        }
      })
    }
  }

  viewOrderDetail() {
    this.goDetails()
  }
}

export default HistoryOrder
</script>
